module.exports = __webpack_public_path__ + "static/img/loading@2x.5add32b4.gif";